/**
 * Rejects when `promise` has not settled within `ms`. The timer is cleared as soon as the promise
 * settles, so a server render never waits on it.
 */
export const withTimeout = (promise, ms, label) => {
    let timer;
    const timeout = new Promise((_, reject) => {
        timer = setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms);
    });
    return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
};
//# sourceMappingURL=with-timeout.js.map